/* eslint-disable tailwindcss/no-custom-classname */
import React, { useMemo } from 'react';
import classnames from 'classnames';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import Button from '../button/Button';
import FrontasticImage from '../frontasticImage';

const getVariantToDisplay = (variant, isVariantColor, formatLabel, selectedSkuFromCart) => {
  if (isVariantColor) {
    return {
      key: variant?.product?.productId,
      sku: variant.product.variants[0]?.sku,
      label: formatLabel ? formatLabel(variant.product) : variant.product,
      isSelectedElement: variant.isActive,
    };
  }

  return {
    key: variant?.sku,
    sku: variant?.sku,
    label: formatLabel ? formatLabel(variant) : variant,
    isSelectedElement: selectedSkuFromCart === variant?.sku,
  };
};

const SelectVariant = ({
  variants,
  onSelectSize,
  onSelectColor,
  formatLabel,
  isVariantSize = false,
  isVariantColor = false,
  selectedSkuFromCart,
  refererStore,
  context,
}) => {
  const listed = [];

  // useEffect(() => {
  //   if (isVariantSize) {
  //     const hasSelectedVariantSize = sortedVariant
  //       .map((variant) => {
  //         const { isSelectedElement } = getVariantToDisplay(variant, false, formatLabel, selectedSkuFromCart);

  //         return isSelectedElement && selectedSkuFromCart === variant?.sku;
  //       })
  //       .includes(true);

  //     if (hasSelectedVariantSize === false) {
  //       onSelect(sortedVariant?.[0]?.currentIndex);
  //     }
  //   }
  // }, [formatLabel, isVariantSize, onSelect, selectedSkuFromCart, sortedVariant]);

  if (!variants || variants.length === 0 || !context) {
    return null;
  }

  return (
    <>
      {variants.map((variant, index) => {
        const { key, sku, label, isSelectedElement } = getVariantToDisplay(
          variant,
          isVariantColor,
          formatLabel,
          selectedSkuFromCart,
        );

        if (isVariantSize && listed.includes(label)) {
          return null;
        }

        listed.push(label);

        return (
          <Button
            type={'button'}
            key={key}
            className={classnames('select-variant-item', {
              'select-variant-active': isSelectedElement,
            })}
            onClick={() => {
              if (isVariantSize) {
                onSelectSize?.(variant.sku);
              }
              if (isVariantColor) {
                onSelectColor?.(variant);
              }
            }}
          >
            <div className="select-variant-button h-full w-full p-0">
              {isVariantSize ? (
                <>
                  {variant.images[0] && (
                    <FrontasticImage src={variant.images[0]} alt={label} title={label} width={50} height={50} />
                  )}
                </>
              ) : (
                <>
                  {variant.product.variants[0].images[0] && (
                    <FrontasticImage
                      src={variant.product.variants[0].images[0]}
                      alt={label}
                      title={label}
                      width={50}
                      height={50}
                    />
                  )}
                </>
              )}

              <div className={'variant-label'} data-insights-object-id={sku}>
                <span>{label}</span>
              </div>
            </div>
          </Button>
        );
      })}
    </>
  );
};

SelectVariant.propTypes = {
  variants: PropTypes.array.isRequired,
  onSelectSize: PropTypes.func,
  onSelectColor: PropTypes.func,
  formatLabel: PropTypes.func,
  isVariantSize: PropTypes.bool,
  isVariantColor: PropTypes.bool,
  refererStore: PropTypes.any,
  selectedSkuFromCart: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SelectVariant;
